/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  idArAsColor: null,
  descripcion: ""
};

const nameItemText = "Color";
//
// ########################################################################### 
//
const ColorDialog = ({
  onSave,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [arAsColores, setArAsColores] = useState([]);
  const [valueACArAsColor, setValueACArAsColor] = useState(null);
  const [inputValueACArAsColor, setInputValueACArAsColor] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadArAsColores();
  }, []);
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (!valueACArAsColor) {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar un color",
      });
      setShowMessage(true);
      return;
    }

    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {

    const _itemCrud = {
      id: valueACArAsColor.id,
      descripcion_ar_as_color: valueACArAsColor.label,
    };

    const success = onSave(_itemCrud);

    if (success) {
      setItemCrudLocal(initialState);
      setValueACArAsColor(null);
      setInputValueACArAsColor("");
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const loadArAsColores = async () => {
    const response = await getCacheData("ar_as_color")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsColores(_var);
    } else {
      setArAsColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    };
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              ColorDialog: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="id-ar-as-color"
                size="small"
                value={
                  valueACArAsColor && valueACArAsColor.id
                    ? valueACArAsColor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACArAsColor(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idArAsColor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACArAsColor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACArAsColor(newInputValue);
                }}
                options={arAsColores}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Color"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              // evita que abra/cierre el dropdown
                              e.stopPropagation();
                              loadArAsColores();
                            }}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  startIcon={<Add />}
                >
                  Agregar
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                  startIcon={<CloseIcon />}
                >
                  Cerrar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ColorDialog;
